import { StoreAction, XmAction } from 'store/actions';
import { AccountSummary } from './models';

export function accountSummaryReducer(state: AccountSummary, action: XmAction<AccountSummary>): AccountSummary {
    switch (action.type) {
        case StoreAction.GET_ACCOUNT_SUMMARY:
        case StoreAction.GET_SSM_ACCOUNT_SUMMARY_CBM_NO_LEVEL:
        case StoreAction.GET_ACCOUNT_SUMMARY_VIA_SSM_PROXY:
        case StoreAction.GET_ACCOUNT_SUMMARY_FOR_PLAN_EIGHT:
            return action.payload;
        case StoreAction.CLEAR_ACCOUNT_SUMMARY:
            return undefined;
        default:
            return state;
    }
}
